import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Tab } from './tab.type';

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.css']
})
export class BottomNavComponent {

  @Input() activeTab!: Tab;
  @Input() hasReports: boolean = false;

  @Output() tabChange = new EventEmitter<Tab>();

  setTab(tab: Tab): void {
    this.tabChange.emit(tab);
  }

}
